import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface GetClaimReasonCommentQueryArgs {
  claimId: string;
}

export const getClaimReasonCommentRequest = ({
  claimId,
}: GetClaimReasonCommentQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/reasonComment`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimReasonCommentQuery = async (
  args: GetClaimReasonCommentQueryArgs,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      getClaimReasonCommentRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
